// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"112b1f51","239":"309e1e45","453":"98bb53cb","455":"a3f22b00"}[chunkId] + ".chunk.js";
};